<template>
  <div>
    <div v-show="saving" class="mask middle-level"></div>

    <div v-for="(item, index) in options" :key="item.id">
      <mu-row class="subject-option-type-text">
        <mu-col span="12" class="subject-option">
          <div ref="control" class="subject-flex">
            <!-- 单选题 选项 -->
            <mu-radio
              v-if="type === 1"
              v-model="currentAnswer"
              :disabled="disableForm"
              :value="format(index)"
              class="subject-option-button"
              @change="setCurrentAnswer(item.id)"
            ></mu-radio>

            <!-- 多选题 选项 -->
            <mu-checkbox
              v-if="type === 2"
              v-model="checkbox"
              :disabled="disableForm"
              :value="format(index)"
              class="subject-option-button"
              @change="setCurrentAnswer(item.id)"
            ></mu-checkbox>

            <!-- 判断题 选项 -->
            <mu-radio
              v-if="type === 5"
              v-model="currentAnswer"
              :disabled="disableForm"
              :value="format(index)"
              class="subject-option-button"
              @change="setCurrentAnswer(item.id)"
            ></mu-radio>
          </div>
          <div
            class="subject-option-text"
            @click="hitControl(index)"
            v-html="optStr(index, item.title)"
          ></div>
        </mu-col>
        <div class="pic-video">
          <!-- 图片类标题 -->
          <div v-show="item.pic" class="subject-title-icon">
            <img :src="item.pic" />
          </div>
          <!-- 视频 -->
          <video
            v-if="item.video"
            ref="video"
            :src="item.video.PlayURL"
            :poster="item.video.cover"
            webkit-playsinline="true"
            class="video"
            x5-playsinline="true"
            playsinline
            controlsList="nodownload"
            preload="auto"
            controls
          >
            不支持 video 标签
          </video>
        </div>
      </mu-row>
    </div>

    <subject-analysis
      v-show="showAnalysis"
      :is-true="isCorrect"
      :answer-opt="ansOptStr"
      :analysis-str="analysisStr"
    ></subject-analysis>

    <div class="answer-btns">
      <mu-button v-if="btnUp" class="btn-item up" @click="emitUp">
        上一题
      </mu-button>
      <mu-button v-if="btnDown" class="btn-item down" @click="emitDown">
        下一题
      </mu-button>
    </div>
  </div>
</template>

<script>
import SubjectAnalysis from './SubjectAnalysis'
export default {
  components: { SubjectAnalysis },
  filters: {},
  props: {
    // 题目类型
    type: Number,

    answered: [String, Array],

    wasCorrect: Boolean,

    disableReset: Boolean,

    // 禁止选项（查看记录时使用）
    disableForm: Boolean,

    // 选项
    options: Array,

    // 解析功能
    analysis: {
      type: String,
      validator: function (value) {
        // 这个值必须匹配下列字符串中的一个
        return ['normal', 'never', 'always'].indexOf(value) !== -1
      },
      default: 'never',
    },

    // 解析内容
    analysisStr: String,

    // 选项必填
    required: Boolean,

    btnDown: Boolean,
    btnUp: Boolean,
  },
  data() {
    return {
      checkbox: [],
      currentAnswer: null,

      currentAnswerId: null,
      checkboxId: [],

      showAnalysis: false,
      isCorrect: false,

      saving: false, // 选完题后的定时器时差， 不允许用户频繁随意切换选项

      formatObj: {
        alphabet: (e) => {
          return String.fromCharCode(65 + parseInt(e))
        },
        symbol: {
          0: '<i class="material-icons">check</i>',
          1: '<i class="material-icons">close</i>',
        },
      },
    }
  },
  computed: {
    disableAnalysis() {
      return this.analysis === 'never'
    },
    ansOptStr() {
      const _res = this.getCorrectAnswerOpt()
      return this.isMultipleSubject ? _res.join(',') : _res
    },
    userAnsIdStr() {
      const mId = this.checkboxId
      const sId = this.currentAnswerId

      return this.isMultipleSubject ? mId.join(',') : sId
    },

    testParams() {
      const _par = {
        is_correct: this.isCorrectAnswer(this.currentAnswer) ? 1 : 0, // 0 1
        item_id: this.userAnsIdStr, // string
      }
      console.log(
        `testParams 模拟考试选项参数，  回答是否正确: ${_par.is_correct} ， 选项id: ${_par.item_id}`
      )
      return _par
    },

    isMultipleSubject() {
      return this.type === 2
    },
    // 未完成的题目不显示解析
    showAnalysisDetail() {
      return !!this.currentAnswer
    },
  },

  watch: {
    currentAnswer(val) {
      if (this.answered || this.saving || this.isMultipleSubject) return

      if (val === null) return

      const corAns = this.isCorrectAnswer(this.currentAnswer)
      if (this.analysisFun(corAns)) return

      if (this.isRequiredFail()) return

      this.saving = true

      setTimeout(() => {
        if (!this.disableAnalysis || !this.showAnalysis) {
          this.$emit('down')
        }
        this.showAnalysis = false

        this.saving = false

        this.resetAns()
      }, 600)
    },

    checkbox(val) {
      if (this.disableAnalysis) return false

      if (val.length <= 0) {
        // this.showAnalysis = false
        return
      }

      const _res = this.getCorrectAnswerOpt()
      const res_dereplication = Array.from(new Set(_res.concat(val)))
      const isFault = res_dereplication.length > _res.length

      if (isFault) {
        this.analysisFun(false)
        return
      }
      if (!isFault && this.analysis !== 'always') {
        this.showAnalysis = false
      } else {
        this.showAnalysis = true
      }

      if (this.isCorrectAnswer(this.currentAnswer)) {
        this.analysisFun(true)
        this.saving = true

        setTimeout(() => {
          this.$emit('down')
          this.showAnalysis = false

          this.saving = false

          this.resetAns()
        }, 600)
      }
    },

    answered(val) {
      this.answeredFun(val)
    },

    // 第一题也要判断的
    wasCorrect: {
      immediate: true,
      handler(val) {
        if (this.analysis === 'never' || this.analysis === 'normal') return

        this.isCorrect = val
        this.showAnalysis = val !== null
      },
    },
    // 历史错题进入练习模式导致analysis发生变化，这时候需要初始化全部题目的分析内容
    analysis: {
      immediate: true,
      handler(val) {
        if (val === 'normal') {
          this.showAnalysis = false
        }
      },
    },
  },
  created() {
    if (this.analysis === 'always') {
      this.showAnalysis = true
    }
  },
  mounted() {
    const _a = this.answered
    if (_a) {
      this.answeredFun(_a)
    }
  },
  activited() {},
  update() {},
  beforeRouteUpdate() {},
  methods: {
    hitControl(index) {
      const ctr = this.$refs.control[index].querySelector(
        '.subject-option-button'
      )
      ctr && ctr.click()
    },
    isRequiredFail() {
      if (!this.required) return false

      let isFail = false
      if (this.currentAnswer) {
        isFail = this.isMultipleSubject
          ? this.currentAnswer.length <= 0
          : this.currentAnswer === null
      } else {
        isFail = true
      }

      if (isFail) {
        this.$NewToast.message('选项不能为空')
      }

      return isFail
    },

    optStr(index, title) {
      const m1 = this.format(index)
      const m2 = this.type !== 5 ? `） ${title}` : ''
      return `${m1}${m2}`
    },

    setCurrentAnswer(id) {
      if (this.isMultipleSubject) {
        const noDuplicates = this.checkboxId.find((e, i) => {
          if (e === id) {
            this.checkboxId.splice(i, 1)
            return e
          }
        })
        if (!noDuplicates) this.checkboxId.push(id)

        this.currentAnswer = this.checkbox
      } else {
        this.currentAnswerId = id
      }
    },

    format(value) {
      return this.type === 5
        ? this.formatObj.symbol[value]
        : this.formatObj.alphabet(value)
    },

    getCorrectAnswerOpt() {
      const items = this.options
      let res
      if (this.isMultipleSubject) {
        res = []
        items.map((e, i) => {
          if (e.is_answer === 1) {
            res.push(this.format(i))
          }
        })
      } else {
        for (let i = 0; i < items.length; i++) {
          if (items[i].is_answer === 1) {
            res = this.format(i)
            break
          }
        }
      }

      if (!res) {
        throw new Error(
          'SubjectOptions.vue::method.getCorrectAnswerOpt 选项没有正确答案(is_answer没有1)'
        )
      }

      return res
    },

    isCorrectAnswer(ans) {
      if (!ans) return false
      const _res = this.getCorrectAnswerOpt()
      let r

      console.log('isCorrectAnswer: ', _res, ans)
      if (this.isMultipleSubject) {
        if (ans.length < _res.length) return false
        const result = Array.from(new Set(_res.concat(ans))) // 数组 合并 去重
        r = result.length === _res.length
      } else {
        r = _res === ans
      }
      return r
    },

    resetAns() {
      // 清空已答题目的选项
      if (this.isMultipleSubject) {
        this.checkbox = []
        this.checkboxId = []
      } else {
        this.currentAnswerId = null
      }
      this.currentAnswer = null
    },

    answerCorrect() {
      this.isCorrect = true
      this.showAnalysis = false
    },

    answerWrong() {
      this.isCorrect = false
      this.showAnalysis = true
    },

    // 如果显示了解析， 就不自动下一题
    analysisFun(isCor) {
      if (this.disableAnalysis) return false

      if (isCor) {
        this.answerCorrect()
        this.$NewToast.success('回答正确！', 1000)
        return false
      } else {
        this.answerWrong()
        return true
      }
    },

    emitUp() {
      // this.showAnalysis = !(this.analysis === 'normal' && this.showAnalysis)
      console.log('this.showAnalysis', this.showAnalysis)
      this.$emit('up')
    },

    emitDown() {
      if (this.isRequiredFail()) return

      if (this.analysis === 'normal' && this.showAnalysis) {
        this.showAnalysis = false
      }
      if (!this.disableReset) this.resetAns()

      this.$emit('down')
    },

    answeredFun(val) {
      if (val === null) {
        this.resetAns()
        return
      }
      const items = this.options
      let result
      if (this.isMultipleSubject) {
        let _res = []
        items.map((e, i) => {
          val.map((val_e) => {
            if (+e.id === +val_e) {
              _res.push(this.format(i))
            }
          })
        })
        this.checkbox = _res
      } else {
        items.map((e, i) => {
          if (+e.id === +val) {
            result = this.format(i)
            return
          }
        })
        this.currentAnswer = result
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.mask {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.pic-video {
  display: flex;
  flex-flow: column;
}
.subject-title-icon {
  width: 100%;
  margin-bottom: 5px;
  display: flex;
}
.video {
  width: 100%;
  margin-top: 10px;
}
</style>
